import { schemes, zSchema } from "@zeal/common";

export const postCompleteCompanyOnboardingFlowParamsSchema = zSchema.object({
  companyID: schemes.companyID(),
});

export type TPostCompleteCompanyOnboardingFlowParams = zSchema.infer<
  typeof postCompleteCompanyOnboardingFlowParamsSchema
>;

export const postCompleteCompanyOnboardingFlowResponseSchema = zSchema.string();

export type TPostCompleteCompanyOnboardingFlowResponse = zSchema.infer<
  typeof postCompleteCompanyOnboardingFlowResponseSchema
>;
